import * as React from 'react';

import ICheckbox from './ICheckbox';
import { classNames } from '@features/utils/reactFunctions';

import * as style from './CheckboxStyle.module.scss'

export const Checkbox = ({
   label,
   className,
   value,
   checked,
   type = 'checkbox',
   children,
   ...restProps
 }: ICheckbox): JSX.Element => {
  const disablingNotAllowed = checked && { ...restProps }.name === 'nda_accepted';
  return (
    <label
      className={classNames(
        style.checkboxContainer,
        checked && style.checkboxChecked,
        className
      )}
    >
      <input
        className={style.checkboxField}
        type={type}
        value={value}
        checked={checked}
        {...restProps}
      />
      <div
        className={
          classNames(
            style.checkboxCustom,
            disablingNotAllowed && style.checkboxCustomNotAllowed)
          }
      />
      {label && <span className={style.checkboxLabel}>{label}</span>}
      {children}
    </label>
  );
};

export default React.memo(Checkbox);
